import { GuestsType } from 'types/mappedProductData';

import { DEFAULT_PARTNER_KEY } from './constants';

export enum GUEST_TYPES {
  adults = 'adults',
  children = 'children',
  infants = 'infants',
  seniors = 'seniors',
}

export enum FETCH_POLICY {
  cacheAndNetwork = 'cache-and-network',
  cacheFirst = 'cache-first',
  cacheOnly = 'cache-only',
  networkFirst = 'network-first',
  networkOnly = 'network-only',
  noCache = 'no-cache',
  standby = 'standby',
}

export const DEFAULT_MAX_BOOKING_PERIOD = 9999;
export const DEFAULT_MIN_BOOKING_PERIOD = 48;
export const DEFAULT_CANCELLATION_PERIOD = 48;
export const DEFAULT_AMEND_PERIOD = 48;
export const DEFAULT_MAX_PARTY_SIZE = 5;
export const DEFAULT_TIME_SLOT_PERIOD = 15;
export const DEFAULT_CURRENCY = 'GBP';
export const DEFAULT_PRICE = 6;
export const DEFAULT_VIEW_ONLY = false;
export const DEFAULT_LEGACY_PRODUCT = false;

export const DEFAULT_GUESTS_PARAMS = {
  [GUEST_TYPES.adults]: {
    age: '12+',
    isChargeable: true,
    isPartySizeImpacted: true,
    maxCountPerGuestType: 5,
    price: DEFAULT_PRICE,
  },
  [GUEST_TYPES.children]: {
    age: '2-11',
    isChargeable: true,
    isPartySizeImpacted: true,
    maxCountPerGuestType: 5,
    price: DEFAULT_PRICE,
  },
  [GUEST_TYPES.infants]: {
    age: '0-2',
    isChargeable: false,
    isPartySizeImpacted: false,
    maxCountPerGuestType: 5,
    price: 0,
  },
  [GUEST_TYPES.seniors]: {
    age: '65+',
    isChargeable: false,
    isPartySizeImpacted: true,
    maxCountPerGuestType: 5,
    price: DEFAULT_PRICE,
  },
};

export const DEFAULT_GUESTS: GuestsType = {
  [GUEST_TYPES.adults]: DEFAULT_GUESTS_PARAMS[GUEST_TYPES.adults],
  [GUEST_TYPES.children]: DEFAULT_GUESTS_PARAMS[GUEST_TYPES.children],
  [GUEST_TYPES.infants]: DEFAULT_GUESTS_PARAMS[GUEST_TYPES.infants],
};

export const FAQ_PP = 'https://memberhelp.prioritypass.com/en/support/home';
export const FAQ_LK = 'https://www.loungekey.com/en/contact-us';
export const FAQ_AMEX_PREBOOK_ENTITLEMENTS =
  'https://prioritypass.com/pre-book-entitlements';

export const DEFAULT_CONTEXT_PRODUCT_VALUE = {
  airportCode: '',
  airportName: '',
  bookingMaxPeriodAllowed: DEFAULT_MAX_BOOKING_PERIOD,
  bookingMinPeriodAllowed: DEFAULT_MIN_BOOKING_PERIOD,
  cancellationPeriod: DEFAULT_CANCELLATION_PERIOD,
  currency: DEFAULT_CURRENCY,
  guests: DEFAULT_GUESTS,
  imageUrl: '',
  legacyProduct: DEFAULT_LEGACY_PRODUCT,
  loungeCode: '',
  loungeID: '',
  loungeName: '',
  maxPartySize: DEFAULT_MAX_PARTY_SIZE,
  partnerID: '',
  partnerProductID: DEFAULT_PARTNER_KEY,
  productID: '',
  saleprice: DEFAULT_PRICE,
  stripeID: '',
  terminal: '',
  timeSlotPeriod: DEFAULT_TIME_SLOT_PERIOD,
  timezone: '',
  validPrebookPeriod: true,
  viewOnly: DEFAULT_VIEW_ONLY,
};

export const FASTTRACK_IMAGE_URL =
  'https://images.ctfassets.net/687qsr16btly/48U7Yq5FMs6hxoecana05J/3961622dbc56f0a4cdd4667a9248fb9c/fast-track.jpeg?w=500&fm=webp&q=80';

export const ELEVATED_LOUNGES = ['GLA5', 'LGW18', 'LGW19', 'LHR34', 'MAN13'];
export const PLATINUM_SOURCECODES = ['LXPCCEH3BGBG', 'LXPCBEA4BGBG'];
export const CENTURION_SOURCECODES = ['LXCCCEH3BGBG', 'LXCCCEH3SGBG'];

export const PLATINUM_SOURCECODES_TEST = ['BAASTESTFB', 'DEYAN'];
export const CENTURION_SOURCECODES_TEST = ['LXCCEH3BGBG', 'BAASTEST'];

export const SOURCECODE_WITH_STANDARD_PERMISSION = [
  ...PLATINUM_SOURCECODES,
  ...CENTURION_SOURCECODES,
  ...PLATINUM_SOURCECODES_TEST,
  ...CENTURION_SOURCECODES_TEST,
];
export const SOURCECODE_WITH_ELEVATED_PERMISSION = [
  ...CENTURION_SOURCECODES,
  ...CENTURION_SOURCECODES_TEST,
];
